import isBefore from 'date-fns/isBefore'
import React from 'react'
import cardLanguages from '../data/cardLanguages'
import { translationsMapping } from '../../config'
import QuestionMarks from '../components/general/QuestionMarks'
import rarities from '../data/rarities'

export const getPrintNumber = (print, language, userLanguage, returnString = false) => {
	const setNumber = print.language && print.language.alternateSetNumber ? print.language.alternateSetNumber : print.set.setNumber || (returnString ? '????' : <QuestionMarks>????</QuestionMarks>)
	const isReleased = print.set.releaseEu ? isBefore(new Date(print.set.releaseEu), new Date()) : false

	let languageStr

	if (print.language) {
		languageStr = print.language.alternateLanguageCode || cardLanguages[print.language.language].abbr
	} else {
		languageStr = language ? cardLanguages[language].abbr : translationsMapping[userLanguage].toUpperCase()
	}

	return returnString
		? `${setNumber}${print.cardNumber !== '' && print.cardNumber !== null ? `-${languageStr}${print.cardNumber}` : ''}${!isReleased && (print.cardNumber === '' || print.cardNumber === null) ? `-${languageStr}???` : ''}`
		: (
			<>
				{setNumber}
				{print.cardNumber !== '' && print.cardNumber !== null && <>-{languageStr}{print.cardNumber}</>}
				{!isReleased && (print.cardNumber === '' || print.cardNumber === null) && <>-{languageStr}<QuestionMarks>???</QuestionMarks></>}
			</>
		)
}

export const sortByRarity = (a, b, sortByDirection = 'ASC', caller = null) => {
	if (a.rarity && !b.rarity) return -1
	if (!a.rarity && b.rarity) return 1

	const aOrder = a.rarity ? rarities[a.rarity].order || 0 : 0
	const bOrder = b.rarity ? rarities[b.rarity].order || 0 : 0

	if (aOrder < bOrder) return sortByDirection === 'DESC' ? -1 : 1
	if (aOrder > bOrder) return sortByDirection === 'DESC' ? 1 : -1

	if (caller !== 'cardNumber') {
		return sortByCardNumber(a, b, 'ASC', 'rarity')
	}

	return 0
}

export const sortByCardNumber = (a, b, sortByDirection = 'ASC', caller = null) => {
	// set
	const aSet = a.set && a.set.setNumber
	const bSet = b.set && b.set.setNumber

	if (aSet < bSet) return -1
	if (aSet > bSet) return 1

	// cardNumber
	const aNumber = a.cardNumber || 'Z1000'
	const bNumber = b.cardNumber || 'Z1000'

	if (aNumber > bNumber) return sortByDirection === 'DESC' ? -1 : 1
	if (aNumber < bNumber) return sortByDirection === 'DESC' ? 1 : -1

	// artworkNumber
	if (a.artworkNumber && b.artworkNumber) {
		return a.artworkNumber < b.artworkNumber ? -1 : 1
	}

	// name
	const aEntity = a.card ? a.card : a.set || a
	const bEntity = b.card ? b.card : b.set || b

	const aName = aEntity.name || aEntity.nameEn
	const bName = bEntity.name || bEntity.nameEn

	if (aName !== bName) {
		aName.localeCompare(bName, 'en', {
			numeric: true,
			sensitivity: 'base'
		})
	}

	if (caller !== 'rarity') {
		return sortByRarity(a, b, 'ASC', 'cardNumber')
	}

	return 0
}
